import { Button, Divider, Form, Input, Select } from "antd";
import { observer } from "mobx-react";
import { useEffect, useCallback } from "react";
import { __ } from "../../../../utils";
import { EAffiliateCurrency } from "@devowl-wp/api-real-commerce";
import { useStores } from "../../../../store";
const AccountAffiliateSignUpPaymentDetailsFields = observer(_ref => {
  let {
    form,
    toggleEdit: [isEditMode, setEditMode]
  } = _ref;
  const {
    accountStore: {
      isAffiliate,
      session
    }
  } = useStores();
  const toggleEditMode = useCallback(() => {
    setEditMode(prevState => !prevState);
  }, []);
  const isAffiliateFieldDisabled = isAffiliate && !isEditMode;
  useEffect(() => {
    if (!isAffiliate) {
      return;
    }
    if (isEditMode) {
      // The following fields are truncated and should not be filled in edit form
      // See `backends/real-commerce/src/entity/affiliate/payment-details.ts#truncate`
      form.setFieldsValue({
        affiliate: {
          paymentDetails: {
            iban: "",
            ukSortCode: "",
            ukAccountNumber: "",
            achRoutingNumber: "",
            achAccountNumber: "",
            isTruncate: false
          }
        }
      });
    } else {
      // Reset fields to original values
      const {
        affiliate: {
          paymentDetails: {
            accountHolder,
            currency,
            achAccountNumber,
            achRoutingNumber,
            iban,
            ukAccountNumber,
            ukSortCode
          }
        }
      } = session;
      form.setFieldsValue({
        affiliate: {
          paymentDetails: {
            accountHolder,
            currency,
            achAccountNumber,
            achRoutingNumber,
            iban,
            ukAccountNumber,
            ukSortCode,
            isTruncate: true
          }
        }
      });
    }
  }, [isAffiliate, session, form, isEditMode]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    orientation: "left"
  }, __("Payment details for payouts"), isAffiliate && /*#__PURE__*/React.createElement(Button, {
    size: "small",
    style: {
      marginLeft: 15
    },
    onClick: toggleEditMode
  }, isEditMode ? __("Cancel edit") : __("Edit"))), /*#__PURE__*/React.createElement(Form.Item, {
    noStyle: true,
    shouldUpdate: (_ref2, _ref3) => {
      let {
        affiliate: {
          paymentDetails: prevPd
        }
      } = _ref2;
      let {
        affiliate: {
          paymentDetails: nextPd
        }
      } = _ref3;
      return (prevPd === null || prevPd === void 0 ? void 0 : prevPd.currency) !== (nextPd === null || nextPd === void 0 ? void 0 : nextPd.currency);
    }
  }, _ref4 => {
    let {
      getFieldValue
    } = _ref4;
    const currency = getFieldValue(["affiliate", "paymentDetails", "currency"]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, isAffiliate && /*#__PURE__*/React.createElement(Form.Item, {
      noStyle: true,
      name: ["affiliate", "paymentDetails", "isTruncate"]
    }, /*#__PURE__*/React.createElement(Input, {
      type: "hidden"
    })), /*#__PURE__*/React.createElement(Form.Item, {
      label: __("Currency"),
      extra: __("Depending on the currency of the payout, fees may apply according to the ATC. Payouts in EUR via SEPA are free of charge."),
      required: true
    }, /*#__PURE__*/React.createElement(Form.Item, {
      noStyle: true,
      name: ["affiliate", "paymentDetails", "currency"],
      rules: [{
        required: true,
        message: __("Please select the currency in which you would like to receive payouts!")
      }]
    }, /*#__PURE__*/React.createElement(Select, {
      disabled: isAffiliateFieldDisabled
    }, Object.values(EAffiliateCurrency).map(currency => /*#__PURE__*/React.createElement(Select.Option, {
      key: currency,
      value: currency
    }, currency))))), currency !== undefined && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Item, {
      name: ["affiliate", "paymentDetails", "accountHolder"],
      label: __("Account holder"),
      required: true,
      rules: [{
        required: true,
        message: __("Please enter the full name of the account holder!")
      }]
    }, /*#__PURE__*/React.createElement(Input, {
      disabled: isAffiliateFieldDisabled
    })), currency === EAffiliateCurrency.EUR ? /*#__PURE__*/React.createElement(Form.Item, {
      name: ["affiliate", "paymentDetails", "iban"],
      label: __("IBAN"),
      required: true,
      rules: [{
        required: true,
        message: __("Please enter your IBAN!")
      }]
    }, /*#__PURE__*/React.createElement(Input, {
      disabled: isAffiliateFieldDisabled
    })) : currency === EAffiliateCurrency.GBP ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Item, {
      name: ["affiliate", "paymentDetails", "ukSortCode"],
      label: __("UK Sort code"),
      required: true,
      rules: [{
        required: true,
        message: __("Please enter your UK Sort code!")
      }]
    }, /*#__PURE__*/React.createElement(Input, {
      disabled: isAffiliateFieldDisabled
    })), /*#__PURE__*/React.createElement(Form.Item, {
      name: ["affiliate", "paymentDetails", "ukAccountNumber"],
      label: __("Account number"),
      required: true,
      rules: [{
        required: true,
        message: __("Please enter your account number!")
      }]
    }, /*#__PURE__*/React.createElement(Input, {
      disabled: isAffiliateFieldDisabled
    }))) : currency === EAffiliateCurrency.USD ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Item, {
      name: ["affiliate", "paymentDetails", "achRoutingNumber"],
      label: __("ACH routing number"),
      required: true,
      rules: [{
        required: true,
        message: __("Please enter your ACH routing number!")
      }]
    }, /*#__PURE__*/React.createElement(Input, {
      disabled: isAffiliateFieldDisabled
    })), /*#__PURE__*/React.createElement(Form.Item, {
      name: ["affiliate", "paymentDetails", "achAccountNumber"],
      label: __("Account number"),
      required: true,
      rules: [{
        required: true,
        message: __("Please enter your account number!")
      }]
    }, /*#__PURE__*/React.createElement(Input, {
      disabled: isAffiliateFieldDisabled
    }))) : null));
  }));
});
export { AccountAffiliateSignUpPaymentDetailsFields };